import {createContext} from "react";

export const MarkupContext = createContext(null);
